import React, { useEffect, useState } from 'react';
import api from '../../lib/api';
import NotFound from '../../pages/NotFound';

// One request per page load, shared by every gated route.
let menuConfigPromise = null;
const loadMenuConfig = () => {
  if (!menuConfigPromise) {
    menuConfigPromise = api.get('/settings/menu')
      .then(r => r.data || {})
      // No menu settings saved yet (404) or a network error: treat every section as open,
      // same as the Navbar fallback.
      .catch(() => ({}));
  }
  return menuConfigPromise;
};

/**
 * Renders its children only when the section `menuKey` is not switched off in
 * Admin → Menü Ayarları. A section that is off shows the 404 page, so a hidden
 * menu item cannot be reached by typing or sharing its URL.
 */
export function MenuGate({ menuKey, children }) {
  const [enabled, setEnabled] = useState(null);

  useEffect(() => {
    let alive = true;
    loadMenuConfig().then(cfg => { if (alive) setEnabled(cfg[menuKey] !== false); });
    return () => { alive = false; };
  }, [menuKey]);

  if (enabled === null) return <div className="min-h-[70vh]" />;
  return enabled ? children : <NotFound />;
}
